"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PASSWORD_DISALLOWED_WORDS = void 0;
exports.PASSWORD_DISALLOWED_WORDS = [
    "kennwort",
    "passwort",
    "passw0rt",
    "password",
    "passw0rd",
    "admin",
    "finanzen",
    "finance",
    "münchen",
    "finway",
    "azubi",
    "geheim",
    "secret",
    "&actuser",
    "juden",
    "judenraus",
    "neger",
    "indianer",
    "eskimo",
    "ausländer",
    "migranten",
    "rasse",
    "schwarze",
    "sinti",
    "reisfresser",
    "hure",
    "fotze",
    "schwanz",
    "weiße",
    "arier",
    "hitler",
    "holocaust",
    "nutte",
    "behinder",
    "idiot",
    "judenschwein",
    "nigger",
    "analritter",
    "arsch",
    "bumsen",
    "dödel",
    "fick",
    "hure",
    "muschi",
    "nackt",
    "neger",
    "nigger",
    "onanieren",
    "orgasmus",
    "penis",
    "pimmel",
    "pimpern",
    "pinkeln",
    "pissen",
    "schlampe",
    "scheiße",
    "schnackeln",
    "vollpfosten",
    "wichse",
    "wichsen",
    "wichser",
    "acrotomophilia",
    "alabama hot pocket",
    "alaskan pipeline",
    "anal",
    "anilingus",
    "anus",
    "apeshit",
    "arsehole",
    "ass",
    "asshole",
    "assmunch",
    "auto erotic",
    "autoerotic",
    "babeland",
    "baby batter",
    "baby juice",
    "bangbros",
    "beaver lips",
    "beastiality",
    "bestiality",
    "bitch",
    "black cock",
    "blonde action",
    "blowjob",
    "blow job",
    "blow your load",
    "blue waffle",
    "blumpkin",
    "bollocks",
    "bondage",
    "boner",
    "boob",
    "boobs",
    "booty call",
    "brown showers",
    "brunette action",
    "bukkake",
    "bulldyke",
    "bullet vibe",
    "bullshit",
    "bung hole",
    "bunghole",
    "busty",
    "butt",
    "camwhore",
    "cock",
    "creampie",
    "cum",
    "cumming",
    "cumshot",
    "cumshots",
    "cunnilingus",
    "cunt",
    "dick",
    "dildo",
    "domination",
    "dominatrix",
    "dommes",
    "eat my ass",
    "erotic",
    "erotism",
    "escort",
    "eunuch",
    "fag",
    "faggot",
    "fecal",
    "felch",
    "fellatio",
    "feltch",
    "female squirting",
    "femdom",
    "figging",
    "fingerbang",
    "fingering",
    "fisting",
    "foot fetish",
    "footjob",
    "frotting",
    "fuck",
    "futanari",
    "gangbang",
    "gang bang",
    "genitals",
    "handjob",
    "hentai",
    "homoerotic",
    "horny",
    "humping",
    "incest",
    "intercourse",
    "jerk off",
    "kike",
    "kinbaku",
    "kinkster",
    "kinky",
    "knobbing",
    "lolita",
    "lovemaking",
    "make me come",
    "male squirting",
    "motherfucker",
    "nigga",
    "nsfw",
    "nude",
    "nudity",
    "nutten",
    "octopussy",
    "orgasm",
    "orgy",
    "panties",
    "pedobear",
    "pedophile",
    "pegging",
    "penis",
    "piss",
    "playboy",
    "pleasure chest",
    "pole smoker",
    "ponyplay",
    "porno",
    "pubes",
    "pussy",
    "rape",
    "sadism",
    "santorum",
    "sex",
    "shaved",
    "shit",
    "shota",
    "skeet",
    "slut",
    "s&m",
    "strap",
    "suck",
    "suicide",
    "thumbzilla",
    "vagina",
    "xxx",
];
